import type { ComponentProps } from 'react';

import { itemVariants } from '@mint-lib/tw-components';
import { cn } from '@mint-lib/tw-utils';

export const GridMenuItem = ({
  className,
  ...props
}: ComponentProps<'button'>) => {
  return (
    <button
      type="button"
      className={cn(
        itemVariants({
          popoverItem: 'default',
          className:
            'min-w-[200px] items-center justify-items-start whitespace-nowrap disabled:cursor-auto disabled:text-text-disabled',
        }),
        className,
      )}
      {...props}
    />
  );
};
